"use client";

export default function GlobalError({ retry }: { error: Error & { digest?: string }; retry: () => void }) {
  return (
    <html lang="en">
      <body style={{ margin: 0, background: "#09090b", color: "#fafafa", fontFamily: "system-ui, sans-serif" }}>
        <title>Create a Worker — Unable to load</title>
        <main role="alert" style={{ maxWidth: 480, margin: "12vh auto", padding: 24 }}>
          <h1>We couldn’t load the app</h1>
          <p>Please try again. If the problem continues, contact your administrator.</p>
          <button onClick={retry} style={{ padding: "10px 16px", cursor: "pointer" }}>Try again</button>
        </main>
      </body>
    </html>
  );
}
